/* This JS triggers animations*/

export function Animations() {
	animationsInit();
}

let $ = window.jQuery;

function animationsInit() {

	$( window ).load( function () {
		heroAnimations();
	} );

	researchLandingAnimations();

	researchDetailAnimations();

	ourImpactAnimations();

}

function isScrolledIntoView( elem ) {
	const el = $( elem ),
		$window = $( window ),
		viewTop = $window.scrollTop(),
		viewBottom = viewTop + $window.height(), // When element enters from the bottom of the viewport
		// viewBottom = viewTop + ( $window.height() / 2 ), // When the element hits the middle of the viewport
		elTop = el.offset().top,
		elBottom = elTop + el.height(),
		compareTop = elBottom,
		compareBottom = elTop;

	return ( ( compareBottom <= viewBottom ) && ( compareTop >= viewTop ) );
}

function heroAnimations() {
	if ( 0 < $( '.bsd-hero__cover' ).length ) {
		$( '.bsd-hero__cover' ).addClass( 'bsd-animate' );
	}
}

function researchLandingAnimations() {
	if ( 0 < $( '.bsd-phase-story' ).length ) {
		$( window ).scroll( function () {
			$( '.bsd-phase-story' ).each( function () {
				if ( true === isScrolledIntoView( this ) ) {
					$( this ).addClass( 'bsd-animate' );
				}
			} );
		} );
	}
}

function researchDetailAnimations() {
	if ( 0 < $( '.bsd-milestones' ).length ) {
		$( window ).scroll( function () {
			$( '.bsd-milestones' ).each( function () {
				if ( true === isScrolledIntoView( this ) ) {
					$( this ).addClass( 'bsd-animate' );
				}
			} );
		} );
	}
}

function ourImpactAnimations() {
	if ( 0 < $( '.bsd-timeline-pane-card--then' ).length || 0 < $( '.bsd-timeline-pane-card--now' ).length ) {
		$( window ).scroll( function () {
			$( '.bsd-timeline-pane-card--then' ).each( function () {
				if ( true === isScrolledIntoView( this ) ) {
					$( this ).addClass( 'bsd-animate' );
				}
			} );

			$( '.bsd-timeline-pane-card--now' ).each( function () {
				if ( true === isScrolledIntoView( this ) ) {
					$( this ).addClass( 'bsd-animate' );
				}
			} );
		} );
	}
}
